// src/modules/app-views/ticketEvents/pages/Document/tabs/SalesTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import SimpleTable from 'components/SimpleComponents/SimpleTable';
import { useDocumentContext } from 'components/core/DocumentProvider';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const STATUS_TAG_COLOR = {
  confirmed: 'success',
  cancelled: 'error',
  refunded: 'warning',
};

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const TicketEventsSalesTab = () => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { data } = useDocumentContext();

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------
  const sales = data?.ticketSales || [];

  const columns = useMemo(
    () => [
      {
        title: translateX('date'),
        dataIndex: 'purchasedAt',
        width: 140,
        render: value => (value ? dayjs(value).format('DD/MM/YY HH:mm') : '-'),
      },
      {
        title: translateX('buyer'),
        dataIndex: ['_entity', 'fullName'],
        ellipsis: true,
        render: (value, record) => value || record?._entity?.name || record?.entityId || '-',
      },
      {
        title: 'Qde',
        dataIndex: 'quantity',
        width: 60,
        align: 'right',
      },
      {
        title: translateX('price'),
        dataIndex: 'unitPrice',
        width: 110,
        align: 'right',
        render: value => financialService.formatCurrency(value),
      },
      {
        title: 'Valor Total',
        dataIndex: 'totalPrice',
        width: 130,
        align: 'right',
        render: value => (
          <span style={{ color: '#1677ff' }}>{financialService.formatCurrency(value)}</span>
        ),
      },
      {
        title: translateX('status'),
        dataIndex: 'status',
        width: 110,
        align: 'center',
        render: value => (
          <Tag color={STATUS_TAG_COLOR[value] || 'default'}>{translateX(value || 'confirmed')}</Tag>
        ),
      },
    ],
    [],
  );

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <div className="container">
      <SimpleTable
        columns={columns}
        dataSource={sales}
        rowKey="_id"
        size="small"
        pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '50'] }}
      />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default TicketEventsSalesTab;
